import React, { useContext } from "react";
import {
  Redirect,
  Route,
  useLocation
} from "react-router-dom";

import {AuthContext} from '../services/Session/Context'

const ProtectedRoute = ({ path, children }) => {
  const { user } = useContext(AuthContext)
  const location = useLocation();

  if(!user) {
    return <Redirect
      to={{
        pathname: "/login",
        state: { from: location }
      }}
    />
  }
  return <Route exact path={path}> {children} </Route>
}

export default ProtectedRoute
